import React from "react";
import { useNavigate } from "react-router-dom";

const PasswordResetSuccess = () => {
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate("/login");
  };

  return (
    <div className="password-changed-container d-flex align-items-center justify-content-center flex-column">
        <svg width="66" height="77" viewBox="0 0 76 86" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M61.584 49.0835C62.9723 49.0835 64.3198 49.2468 65.6673 49.451V36.8335C65.6673 34.6676 64.8069 32.5903 63.2753 31.0588C61.7438 29.5272 59.6666 28.6668 57.5006 28.6668H53.4173V20.5002C53.4173 9.23016 44.2706 0.0834961 33.0006 0.0834961C21.7306 0.0834961 12.584 9.23016 12.584 20.5002V28.6668H8.50065C6.33472 28.6668 4.25749 29.5272 2.72594 31.0588C1.1944 32.5903 0.333984 34.6676 0.333984 36.8335V77.6668C0.333984 82.1993 3.96815 85.8335 8.50065 85.8335H40.3915C38.309 82.2402 37.084 78.0752 37.084 73.5835C37.084 60.0677 48.0681 49.0835 61.584 49.0835ZM20.7506 20.5002C20.7506 13.7218 26.2223 8.25016 33.0006 8.25016C39.779 8.25016 45.2506 13.7218 45.2506 20.5002V28.6668H20.7506V20.5002ZM33.0006 65.4168C31.3854 65.4168 29.8065 64.9379 28.4635 64.0405C27.1205 63.1431 26.0737 61.8677 25.4556 60.3754C24.8375 58.8831 24.6758 57.2411 24.9909 55.6569C25.306 54.0728 26.0838 52.6176 27.2259 51.4755C28.3681 50.3333 29.8232 49.5555 31.4074 49.2404C32.9916 48.9253 34.6336 49.087 36.1259 49.7051C37.6182 50.3233 38.8936 51.37 39.791 52.713C40.6883 54.056 41.1673 55.635 41.1673 57.2502C41.1673 61.7827 37.5331 65.4168 33.0006 65.4168ZM75.8756 66.4377L56.4798 85.8335L45.2506 73.5835L49.9873 68.8468L56.4798 75.3393L71.139 60.6802L75.8756 66.4377Z" fill="white"/>
        </svg>
        <div className="forgot-header text-center">
            <h3>Password Changed!</h3>
            <p>You’ve successfully completed your Reset Password</p>
        </div>
        <button className="btn-reset-password" onClick={handleLogin}>
        Login Now
      </button>
    </div>
  );
};

export default PasswordResetSuccess;
